import App from "./App.vue";
// import './bootstrap';
// import '../sass/style.scss';
import Router from '@/router';
import store from '@/store';
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { startIdleSession } from "@/core/services/IdleSession";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { ZiggyVue } from '~ziggy-js';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import * as Popper from '@popperjs/core';
import * as bootstrap from '~bootstrap';

window.Popper = Popper;
window.bootstrap = bootstrap;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);

app.config.globalProperties.window = window;

app.use(Router);
app.use(store);
app.use(pinia);

app.use(ZiggyVue);
app.use(ElementPlus);

ApiService.init(app);
startIdleSession();
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount('#app');